var map = {
	"./apple.svg": "3f38",
	"./carrot.svg": "5fe5",
	"./cheese.svg": "12c9",
	"./fish.svg": "fd90",
	"./greens.svg": "659c",
	"./meat.svg": "26f4",
	"./sausage.svg": "261b",
	"./shrimp.svg": "28c2",
	"./wtf.svg": "7edc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0493";